import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Loader from "../../../components/Loader/Loader";
import { FormGroup, Input, Label } from "reactstrap";
import { connect } from "react-redux";
import {
  getAdminPaymentDetails,
  saveAdminPaymentSetting,
} from "../../../actions/paymentAction";
import isEmpty from "../../../validation/is-empty";
import { notification } from "../../../utils/utility";
import Tooltip from "../../../components/Tooltip";
import PageHeader from "../../../components/PageHeader/PageHeader";

const validation = Yup.object().shape({
  paypal_client_id: Yup.string().required("Paypal Client id is required"),
  paypal_client_secret: Yup.string().required("API password is required"),
  //stripe_publishable_key: Yup.string().required("Publishable key is required"),
  //stripe_secret_key: Yup.string().required("Secret key is required"),
});

let initialValues = {
  paypal_client_id: "",
  paypal_client_secret: "",
  //stripe_publishable_key: "",
  //stripe_secret_key: "",
};

const PaymentSettings = (props) => {
  const [formValues, setFormValues] = useState(null);
  const [pageLoading, setPageLoading] = useState(false);

  useEffect(() => {
    const { getAdminPaymentDetails } = props;
    setPageLoading(true);
    getAdminPaymentDetails({
      data: {},
      onSuccess: function (response) {
        if (!isEmpty(response)) {
          setFormValues({
            ...response,
          });
        }
        setPageLoading(false);
      },
      onError: function (error) {
        setPageLoading(false);
      },
    });
  }, []);

  return (
    <>
      <PageHeader
        title="Payment Settings"
        subtitle="Choose how you collect payments for bookings."
        tooltipCode="P20F1"
      />
      <Loader isShowLoader={pageLoading} />
      <section
        className="rd_vacationfilterpart d-block"
        style={{ padding: "20px 30px" }}
      >
        <Formik
          //validationSchema={validation}
          initialValues={formValues || initialValues}
          enableReinitialize
          onSubmit={(values) => {
            const { saveAdminPaymentSetting } = props;
            let data = {
              ...values,
            };

            setPageLoading(true);
            saveAdminPaymentSetting({
              data,
              onSuccess: (response) => {
                if (response.success) {
                  notification.success(response.message);
                }
                setPageLoading(false);
              },
              onError: (error) => {
                notification.error(error);

                setPageLoading(false);
                console.log("company error ", error);
              },
            });
          }}
        >
          {(formProps) => {
            const { values, errors, touched, handleChange, setFieldValue } =
              formProps;
            return (
              <Form>
                {/* Paypal */}
                <div className="pay-method-paypal">
                  <h3 className="custom_title">Paypal</h3>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label htmlFor="paypalClientId">Paypal Client ID <Tooltip code="P20F6" /> </Label>
                        <Input
                          type="text"
                          id="paypalClientId"
                          placeholder="Paypal Client ID"
                          value={values.paypal_client_id}
                          onChange={(event) => {
                            handleChange({
                              target: {
                                name: "paypal_client_id",
                                value: event.target.value,
                              },
                            });
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <Label htmlFor="paypalClientSecret">Paypal Client Secret <Tooltip code="P20F7" /> </Label>
                        <Input
                          type="password"
                          id="paypalClientSecret"
                          placeholder="Paypal Client Secret"
                          value={values.paypal_client_secret}
                          onChange={(event) => {
                            handleChange({
                              target: {
                                name: "paypal_client_secret",
                                value: event.target.value,
                              },
                            });
                          }}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div>
                {/* Stripe */}
                {/* <div className="pay-method-stripe">
                  <h3 className="custom_title">Stripe</h3>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <FormGroup>
                        <Label htmlFor="stripeSecretKey">
                          Secret Key <Tooltip code="P20F9" />
                        </Label>
                        <Input
                          type="password"
                          id="stripeSecretKey"
                          placeholder="Secret Key"
                          value={values.stripe_secret_key}
                          onChange={(event) => {
                            handleChange({
                              target: {
                                name: "stripe_secret_key",
                                value: event.target.value,
                              },
                            });
                          }}
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <Label htmlFor="stripePublishKey">
                          Publishable Key <Tooltip code="P20F10" />
                        </Label>
                        <Input
                          type="text"
                          id="stripePublishKey"
                          placeholder="Publishable Key"
                          value={values.stripe_publishable_key}
                          onChange={(event) => {
                            handleChange({
                              target: {
                                name: "stripe_publishable_key",
                                value: event.target.value,
                              },
                            });
                          }}
                        />
                      </FormGroup>
                    </div>
                  </div>
                </div> */}
                <div className="save_changes d-flex justify-content-end">
                  <div className="col-auto px-0">
                    <button className="btn btn-app" type="submit">
                      Save Changes
                    </button>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </section>
    </>
  );
};

export default connect(null, {
  getAdminPaymentDetails,
  saveAdminPaymentSetting,
})(PaymentSettings);
